import Loader from 'components/Kizen/Loader';
import { ContactsSection } from 'pages/Settings/pages/Team/PermissionGroupModal/ContactsSection';

const ContactSectionCard = ({ isLoading }) => {
  if (isLoading) {
    return <Loader loading />;
  }

  return (
    <ContactsSection
      showArrowBtn={false}
      initialExpanderState={'open'}
      showSwitchToggle={false}
      disableMargin
    />
  );
};

export default ContactSectionCard;
